import React from "react";
import { Link } from "react-router-dom";
import { FaFacebook, FaTwitter, FaInstagram, FaYoutube } from "react-icons/fa";
import "./Footer.css";

function Footer({ onePage = false }) {
  const navLinks = onePage
    ? [
        { anchor: "#accueil", label: "Accueil" },
        { anchor: "#a-propos", label: "À propos" },
        { anchor: "#solutions", label: "Nos solutions" },
        { anchor: "#solutions-ecoles", label: "Solutions écoles" },
        { anchor: "#solutions-pme", label: "Solutions PME" },
        { anchor: "#nos-realisations", label: "Nos réalisations" },
        { anchor: "#contact", label: "Contact / Audit" },
      ]
    : [
        { path: "/", label: "Accueil" },
        { path: "/about", label: "À propos" },
        { path: "/services", label: "Nos solutions" },
        { path: "/solutions-ecoles", label: "Solutions écoles" },
        { path: "/solutions-pme", label: "Solutions PME" },
        { path: "/nos-realisations", label: "Nos réalisations" },
        { path: "/contact", label: "Contact / Audit" },
      ];

  return (
    <footer className="footer-shell">
      <div className="footer-container">
        <div className="footer-contact">
          <h3>SAMOL TECHNOLOGIES (SATECH)</h3>
          <ul>
            <li>
              <span className="footer-contact-label">Téléphone :</span>{" "}
              <a href="tel:+2250709046740">+225 0709046740</a> -{" "}
              <a href="tel:+2250554812692">0554812692</a>
            </li>
            <li>
              <span className="footer-contact-label">Email :</span>{" "}
              <a href="mailto:contact@samol-tech.com">contact@samol-tech.com</a>
            </li>
            <li>
              <span className="footer-contact-label">Localisation :</span> Côte d'Ivoire - Abidjan
            </li>
            <li>
              <span className="footer-contact-label">Horaires :</span> Lun-Ven de 08h00 à 18h00, Samedi de 08h00 à 12h00
            </li>
          </ul>
        </div>

        <div className="footer-nav">
          <h3>Navigation</h3>
          <ul>
            {navLinks.map((item) => (
              <li key={item.path || item.anchor}>
                {item.anchor ? <a href={item.anchor}>{item.label}</a> : <Link to={item.path}>{item.label}</Link>}
              </li>
            ))}
          </ul>
          <a href="politique-confidentialite.html">Politique de confidentialité</a>
        </div>

        <div className="footer-newsletter">
          {onePage ? (
            <a className="footer-cta" href="#contact">
              Demander un audit gratuit
            </a>
          ) : (
            <Link className="footer-cta" to="/contact">
              Demander un audit gratuit
            </Link>
          )}
        </div>

        <div className="footer-social-media">
          <h3>Nous suivre</h3>
          <div className="footer-social-media-logos">
            <a href="https://www.facebook.com/" target="_blank" rel="noreferrer">
              <FaFacebook />
            </a>
            <a href="https://twitter.com/" target="_blank" rel="noreferrer">
              <FaTwitter />
            </a>
            <a href="https://www.instagram.com/" target="_blank" rel="noreferrer">
              <FaInstagram />
            </a>
            <a href="https://www.youtube.com/" target="_blank" rel="noreferrer">
              <FaYoutube />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
